module.exports = __webpack_public_path__ + "img/kone-lift-sm.b3b9489e.svg";